// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs__dropdown-option{height:38px;padding-left:8px;padding-top:7px}.vs__dropdown-option--highlight{background:#e0e3f0;color:#000}.vs__dropdown-menu{min-width:100px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
